<template>
  <div class="height-100">

    <creating
      v-if="creating"
      height="100%" />

    <div
      v-if="!creating"
      class="vflex">
      <div class="vflex-row-0 vflex-header p-3 pt-4">
        <h5 class="p-0">{{ $d(new Date(), 'monthYear') }}</h5>
      </div>

      <div class="vflex-row-0 p-3">
        <div style="overflow: hidden;">
          <div class="row">
            <div class="col-sm-4">
              <div class="card my-2">
                <div class="card-header">
                  Limite
                </div>
                <div class="card-body">
                  <span style="font-size: 20px;">{{ resume.current.limit || 0 }}</span>
                </div>
              </div>
            </div>
            <div class="col-sm-4">
              <div class="card my-2">
                <div class="card-header">
                  Usados
                </div>
                <div class="card-body">
                  <router-link
                    :to="`/billing/consumption/${modelType}/details/${currentPeriod}`">
                    <span style="font-size: 20px;">{{ resume.current.used }}</span>
                  </router-link>
                </div>
              </div>
            </div>
            <div class="col-sm-4">
              <div class="card my-2">
                <div class="card-header">
                  Restantes
                </div>
                <div class="card-body">
                  <span style="font-size: 20px;">{{ resume.current.remaining }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="vflex-row-0 p-3 vflex-header">
        <h5 class="p-0">Histórico</h5>
      </div>

      <div class="vflex-row-1">
        <table
          v-if="resume.history.length"
          class="table">
          <thead>
            <tr>
              <th>{{ $t('Mês') }}</th>
              <th>{{ $t('Total') }}</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(item, index) in resume.history"
              :key="index">
              <td class="text-truncate">
                {{ $d(new Date(`${item.date}-02`), 'monthYear') }}
              </td>
              <td class="text-truncate">
                <router-link :to="`/billing/consumption/${modelType}/details/${item.date}`">
                  {{ item.total }}
                </router-link>
              </td>
            </tr>
          </tbody>
        </table>
        <no-results
          v-if="!resume.history.length"
          class="p-3">
          {{ $t('There are no items') }}
          </no-results>
      </div>
    </div>

  </div>
</template>

<script>
import moment from 'moment'

export default {
  name: 'Consumption',
  components: {
  },
  data () {
    return {
      resume: null,
      creating: true
    }
  },
  computed: {
    modelType () {
      return this.$route.params.type || 'parse-resume'
    },
    route () {
      return this.$route
    },
    currentPeriod () {
      return moment().format('YYYY-MM')
    }
  },
  watch: {
    route (to, from) {
      this.loadResume()
    }
  },
  created () {
    this.loadResume()
  },
  methods: {
    /*
    loadResume
    */
    loadResume () {
      this.resume = null
      this.creating = true
      return this.axios.get('/accounts/' + this.$store.getters.getAccount._id + '/consumptions/' + this.modelType + '/resume', {}).then(response => {
        this.resume = response.data
        this.creating = false
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>



// WEBPACK FOOTER //
// src/components/BillingConsumption/BillingConsumptionResume.vue